import { createResource, type ResourceFetcher, type ResourceSource } from "solid-js"

export function createDashboardResource<T, S>(source: ResourceSource<S>, fetcher: ResourceFetcher<S, T>) {
  const [resource, actions] = createResource(source, fetcher)
  // Background saves must not re-enter the page's Suspense fallback and hide
  // the canvas (including its focused editor and local interaction state).
  return [() => resource.latest, {
    ...actions,
    get loading() { return resource.loading },
    get error() { return resource.error },
  }] as const
}
